import React from 'react'

import '../css/Logo.css'

class Logo extends React.Component {
    render() {
        return (
            <div className='logo'>
                
            </div>
        )
    }
}

export default Logo